/** Mixed product gallery: image URL strings and YouTube slide objects. */

export function extractYoutubeId(raw) {
  const s = String(raw || "").trim();
  if (!s) return null;
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
  let url = s;
  if (!/^https?:\/\//i.test(url)) url = `https://${url}`;
  try {
    const u = new URL(url);
    const v = u.searchParams.get("v");
    if (v && /^[A-Za-z0-9_-]{11}$/.test(v)) return v;
    const m = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|shorts\/|live\/|v\/|watch\/))([A-Za-z0-9_-]{11})/);
    return m ? m[1] : null;
  } catch {
    return null;
  }
}

export function youtubeThumb(videoId) {
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}

export function youtubeEmbed(videoId) {
  return `https://www.youtube.com/embed/${videoId}?rel=0`;
}

export function parseGalleryItem(item) {
  if (item == null || item === "") return null;
  if (typeof item === "string") {
    const yt = extractYoutubeId(item);
    if (yt) return { type: "youtube", url: item, video_id: yt };
    return { type: "image", url: item };
  }
  if (typeof item === "object") {
    const typ = String(item.type || "").toLowerCase();
    const url = String(item.url || item.src || "").trim();
    const vid = extractYoutubeId(item.video_id) || extractYoutubeId(url);
    if (typ === "youtube" || vid) {
      if (!vid) return null;
      return { type: "youtube", url: url || `https://www.youtube.com/watch?v=${vid}`, video_id: vid };
    }
    if (url) return { type: "image", url };
  }
  return null;
}

export function listingImageUrl(images) {
  const items = (images || []).map(parseGalleryItem).filter(Boolean);
  const img = items.find((x) => x.type === "image");
  if (img) return img.url;
  const yt = items.find((x) => x.type === "youtube");
  return yt ? youtubeThumb(yt.video_id) : null;
}

export function gallerySlides(images) {
  return (images || []).map(parseGalleryItem).filter(Boolean);
}
